import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function DraggableProductImage({ images, title, className = '' }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dragX, setDragX] = useState(0);

  const handleDrag = (event, info) => {
    setDragX(info.offset.x);
  };

  const handleDragEnd = (event, info) => {
    const swipeThreshold = 50;
    
    if (info.offset.x > swipeThreshold && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else if (info.offset.x < -swipeThreshold && currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
    
    setDragX(0);
  };

  return (
    <div className="relative touch-pan-y px-4 md:px-0">
      {/* Image indicators */}
      <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentIndex ? 'bg-berleto-warmgray w-6' : 'bg-berleto-sage/30'
            }`}
          />
        ))}
      </div>

      {/* Image Container with fixed position */}
      <div className="relative overflow-hidden">
        <motion.div
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={0.2}
          onDrag={handleDrag}
          onDragEnd={handleDragEnd}
          animate={{ x: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="cursor-grab active:cursor-grabbing"
          style={{
            opacity: Math.abs(dragX) > 10 ? 0.8 : 1,
          }}
        >
          <AnimatePresence mode="wait">
            <motion.img
              key={currentIndex}
              src={images[currentIndex]}
              alt={`${title} view ${currentIndex + 1}`}
              className={`w-full ${className || 'max-w-sm md:max-w-md mx-auto'} drop-shadow-xl pointer-events-none select-none`}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              draggable={false}
            />
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Instructions */}
      <p className="text-center text-sm text-berleto-sage mt-12 opacity-60">
        Drag or tap dots to rotate
      </p>
    </div>
  );
}